"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var SavedLineItemsOverlay_1 = __importDefault(require("./SavedLineItemsOverlay"));
var ItemTypes_1 = require("QuoteV2/Models/ItemTypes");
var SavedLineItemsService_1 = require("./SavedLineItemsService");
var lodash_1 = require("lodash");
var SavedLineItemsLibrary = (function () {
    function SavedLineItemsLibrary(invoke, environment, account, variableService, uniqueId, currenciesList, apiBaseUrl, user) {
        var _this = this;
        this.invoke = invoke;
        this.environment = environment;
        this.account = account;
        this.variableService = variableService;
        this.uniqueId = uniqueId;
        this.currenciesList = currenciesList;
        this.apiBaseUrl = apiBaseUrl;
        this.user = user;
        if (account.settings.modules.quote == null) {
            account.settings.modules.quote = {};
        }
        if (account.settings.modules.quote.unitNames == null) {
            account.settings.modules.quote.unitNames = [];
        }
        this._retrievedSavedLineItems = [];
        this._savedLineItemsToAdd = [];
        this.open = function (currency) {
            return (0, SavedLineItemsService_1.retrieveSavedLineItems)(apiBaseUrl, user._id).then(function (savedLineItems) {
                var e_1, _a;
                _this._retrievedSavedLineItems = savedLineItems;
                try {
                    for (var savedLineItems_1 = __values(savedLineItems), savedLineItems_1_1 = savedLineItems_1.next(); !savedLineItems_1_1.done; savedLineItems_1_1 = savedLineItems_1.next()) {
                        var item = savedLineItems_1_1.value;
                        item.$selected = false;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (savedLineItems_1_1 && !savedLineItems_1_1.done && (_a = savedLineItems_1.return)) _a.call(savedLineItems_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return invoke(SavedLineItemsOverlay_1.default, null, {
                    savedLineItems: savedLineItems,
                    currentCurrency: currency,
                    savedLineItemsLibrary: _this,
                });
            });
        };
        this.saveLineItem = function (currency, lineItem) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this.saveLineItems(currency, [lineItem])];
            });
        }); };
        this.saveLineItems = function (currency, lineItems) { return __awaiter(_this, void 0, Promise, function () {
            var lineItem, lineItems_1, lineItems_1_1, templatedItems, lineItems_2, lineItems_2_1, addedUnits, templatedItems_1, templatedItems_1_1, err_1, addedUnits_1, addedUnits_1_1, unit;
            var e_2, _a, e_3, _b, e_4, _c, _d, e_5, _e;
            var _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (currency == null || currency === "") {
                            throw new Error("No currency given");
                        }
                        if (currenciesList.get(currency) == null) {
                            throw new Error("Invalid currency given");
                        }
                        if (lineItems == null || !(0, lodash_1.isArray)(lineItems)) {
                            throw new Error("Array not given for line items");
                        }
                        try {
                            for (lineItems_1 = __values(lineItems), lineItems_1_1 = lineItems_1.next(); !lineItems_1_1.done; lineItems_1_1 = lineItems_1.next()) {
                                lineItem = lineItems_1_1.value;
                                validateLineItem(lineItem);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (lineItems_1_1 && !lineItems_1_1.done && (_a = lineItems_1.return)) _a.call(lineItems_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        templatedItems = [];
                        try {
                            for (lineItems_2 = __values(lineItems), lineItems_2_1 = lineItems_2.next(); !lineItems_2_1.done; lineItems_2_1 = lineItems_2.next()) {
                                lineItem = lineItems_2_1.value;
                                templatedItems.push(toTemplateQuoteItem(lineItem));
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (lineItems_2_1 && !lineItems_2_1.done && (_b = lineItems_2.return)) _b.call(lineItems_2);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        addedUnits = [];
                        try {
                            for (templatedItems_1 = __values(templatedItems), templatedItems_1_1 = templatedItems_1.next(); !templatedItems_1_1.done; templatedItems_1_1 = templatedItems_1.next()) {
                                lineItem = templatedItems_1_1.value;
                                if (lineItem.type !== "text") {
                                    lineItem.currency = currency;
                                }
                                lineItem.id = uniqueId();
                                this._savedLineItemsToAdd.push(lineItem);
                                if ((_f = lineItem.rate) === null || _f === void 0 ? void 0 : _f.unit) {
                                    addedUnits.push(lineItem.rate.unit);
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (templatedItems_1_1 && !templatedItems_1_1.done && (_c = templatedItems_1.return)) _c.call(templatedItems_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4, (0, SavedLineItemsService_1.addSavedLineItems)(apiBaseUrl, user._id, (0, CleanJson_1.default)(this._savedLineItemsToAdd))];
                    case 2:
                        _g.sent();
                        (_d = this._retrievedSavedLineItems).push.apply(_d, __spreadArray([], __read(this._savedLineItemsToAdd), false));
                        this._savedLineItemsToAdd = [];
                        return [3, 4];
                    case 3:
                        err_1 = _g.sent();
                        throw new Error("Failed to add saved line items:  ".concat(err_1.message));
                    case 4:
                        try {
                            for (addedUnits_1 = __values(addedUnits), addedUnits_1_1 = addedUnits_1.next(); !addedUnits_1_1.done; addedUnits_1_1 = addedUnits_1.next()) {
                                unit = addedUnits_1_1.value;
                                if (!account.settings.modules.quote.unitNames.includes(unit)) {
                                    account.settings.modules.quote.unitNames.push(unit);
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (addedUnits_1_1 && !addedUnits_1_1.done && (_e = addedUnits_1.return)) _e.call(addedUnits_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        return [2];
                }
            });
        }); };
        var validateLineItem = function (item) {
            if (item.type == null) {
                throw new Error("Line item didn't have a type associated with it");
            }
            if (!["text", "fixedCost", "variable"].includes(item.type)) {
                throw new Error("Unknown line item type: '".concat(item.type, "'"));
            }
            switch (item.type) {
                case "text":
                    return validateTextLineItem(item);
                case "fixedCost":
                    return validateFixedCostLineItem(item);
                case "variable":
                    return validateVariableBasedLineItem(item);
                default:
                    throw new Error("Got an unknown line item type: ".concat(item.type));
            }
        };
        var validateTextLineItem = function (item) {
            if (item.description == null) {
                throw new Error("Text line item did not have all required fields");
            }
        };
        var validateFixedCostLineItem = function (item) {
            return validateComplexLineItem(item, ["description", "quantity", "rate"], "Fixed cost");
        };
        var validateVariableBasedLineItem = function (item) {
            validateComplexLineItem(item, ["description", "quantity", "rate"], "Variable based");
            if (variableService.getVariable(item.rate.variableId) == null) {
                throw new Error("Invalid variable id for line item");
            }
        };
        var validateComplexLineItem = function (item, requiredFields, itemType) {
            var e_6, _a;
            var itemsFields = (0, lodash_1.keys)(item);
            try {
                for (var requiredFields_1 = __values(requiredFields), requiredFields_1_1 = requiredFields_1.next(); !requiredFields_1_1.done; requiredFields_1_1 = requiredFields_1.next()) {
                    var requiredField = requiredFields_1_1.value;
                    if (!itemsFields.includes(requiredField)) {
                        throw new Error("".concat(itemType, " line item did not have all required fields"));
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (requiredFields_1_1 && !requiredFields_1_1.done && (_a = requiredFields_1.return)) _a.call(requiredFields_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
            if (item.discount != null && (0, lodash_1.keys)(item.discount).length !== 0) {
                if (item.discount.id != null) {
                    return;
                }
                if (item.discount.units == null || item.discount.type == null) {
                    throw new Error("Discount did not have required fields");
                }
                if (!["fixed", "percent"].includes(item.discount.type)) {
                    throw new Error("Incorrect discount type: ".concat(item.discount.type));
                }
            }
        };
        var toTemplateQuoteItem = function (item) { return new ItemTypes_1.ItemFactory().templateQuoteItem(item.type, item); };
        this.deleteLineItem = function (id) { return __awaiter(_this, void 0, Promise, function () {
            var removedItems;
            return __generator(this, function (_a) {
                if (id == null || id.length === 0) {
                    throw new Error("No id given to delete");
                }
                removedItems = (0, lodash_1.concat)((0, lodash_1.remove)(this._retrievedSavedLineItems, function (item) { return item.id === id; }), (0, lodash_1.remove)(this._savedLineItemsToAdd, function (item) { return item.id === id; }));
                if (removedItems.length === 0) {
                    throw new Error("No line item matches given id");
                }
                return [2, (0, SavedLineItemsService_1.deleteSavedLineItem)(apiBaseUrl, user._id, id)];
            });
        }); };
    }
    SavedLineItemsLibrary.prototype.getAllSavedLineItems = function () {
        return (0, lodash_1.concat)(this._retrievedSavedLineItems, this._savedLineItemsToAdd);
    };
    return SavedLineItemsLibrary;
}());
exports.default = SavedLineItemsLibrary;
